import { render, staticRenderFns } from "./teachingplan-header-actions.vue?vue&type=template&id=43af4032&scoped=true"
import script from "./teachingplan-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./teachingplan-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./teachingplan-header-actions.less?vue&type=style&index=0&id=43af4032&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af4032",
  null
  
)

export default component.exports